import React from 'react';

const pluralTurno = (n) => `${n} turno${n !== 1 ? 's' : ''}`;

// Modal genérico "Solo este turno / Este y los siguientes / Toda la serie",
// usado por drag, resize, edición y cancelación de turnos en serie.
function Modal3Opciones({
  titulo, mensaje, cantFuturos, cantTodos,
  onCancelar, onSoloEste, onEstoYSiguientes, onTodaLaSerie,
  textoCancelar = 'Cancelar', peligro = false,
}) {
  return (
    <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onCancelar(); }}>
      <div className="modal-card modal-card-sm">
        <div className="modal-header">
          <h3>{titulo}</h3>
          <button className="modal-btn-cerrar" onClick={onCancelar}>✕</button>
        </div>
        <div className="modal-body">
          <p className="confirm-mensaje">{mensaje}</p>
          <p className="confirm-alerta">Tiene {pluralTurno(cantFuturos)} futuro{cantFuturos !== 1 ? 's' : ''} agendado{cantFuturos !== 1 ? 's' : ''}.</p>
        </div>
        <div className="modal-acciones-vertical">
          <button className="modal-btn-cancelar" onClick={onCancelar}>{textoCancelar}</button>
          <button className="modal-btn-guardar" onClick={onSoloEste}>Solo este turno</button>
          <button className="modal-btn-guardar modal-btn-guardar-medio" onClick={onEstoYSiguientes}>
            Este y los siguientes ({pluralTurno(cantFuturos + 1)})
          </button>
          <button
            className={peligro ? 'modal-btn-peligro' : 'modal-btn-guardar modal-btn-guardar-fuerte'}
            onClick={onTodaLaSerie}
          >
            Toda la serie ({pluralTurno(cantTodos + 1)})
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal3Opciones;
